module.exports = __webpack_public_path__ + "static/media/insta-15.bb0f20d3.png";